import React, { useRef, useState, useEffect, useCallback } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { makeStyles, createStyles, useTheme } from "@material-ui/core/styles";
import {
  makeSpotlightPeersSelector,
  videoBoxesSelector,
} from "../../helpers/Selectors";
import classnames from "classnames";
import Peer from "../Presence/Peer";
import Me from "../Presence/Me";
import debounce from "../../utils/debounce";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";

const MAX_RATIO = 1.334;
const PADDING_V = 50;
const PADDING_H = 0;

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      alignContent: "center",
      paddingTop: 0,
      paddingBottom: 80,
    },
  })
);
const Democratic = () => {
  const classes = useStyles();
  const peersRef = useRef();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const [peerWidth, setPeerWidth] = useState(0);
  const [peerHeight, setPeerHeight] = useState(0);

  const boxes = useSelector((state) => videoBoxesSelector(state));
  const toolbarsVisible = useSelector((state) => state.room.toolbarsVisible);
  const permanentTopBar = useSelector(
    (state) => state.settings.permanentTopBar
  );
  const spotlightPeers = useSelector((state) => {
    return makeSpotlightPeersSelector(state)(state);
  }, shallowEqual);

  const toolAreaOpen = useSelector((state) => state.toolarea.toolAreaOpen);
  const whiteBoardOpen = useSelector(
    (state) => state.whiteboard.whiteBoardOpen
  );
  const updateDimensions = useCallback(() => {
    if (!peersRef.current) {
      return;
    }

    const n = boxes;

    if (n === 0) {
      return;
    }

    const width = peersRef.current.clientWidth - PADDING_H;
    const height = peersRef.current.clientHeight - PADDING_V;

    const ratio =
      width / height < MAX_RATIO && boxes > 2 ? width / height : MAX_RATIO;

    let x, y, space;

    for (let rows = 1; rows < 100; rows = rows + 1) {
      x = width / Math.ceil(n / rows);
      y = x / ratio;
      if (height < y * rows) {
        y = height / rows;
        x = ratio * y;
        break;
      }
      space = height - y * rows;
      if (space < y) {
        break;
      }
    }
    if (
      Math.ceil(peerWidth) !== Math.ceil(0.94 * x) ||
      Math.ceil(peerHeight) !== Math.ceil(0.94 * y)
    ) {
      setPeerWidth(0.94 * x);
      setPeerHeight(0.94 * y);
    }
  }, [boxes, peerWidth, toolbarsVisible, permanentTopBar]);

  useEffect(() => {
    const debouncedUpdate = debounce(updateDimensions, 250);
    // window.resize event listener
    window.addEventListener("resize", debouncedUpdate);

    updateDimensions();

    return () => {
      window.removeEventListener("resize", debouncedUpdate);
    };
  }, [updateDimensions]);

  useEffect(() => {
    setTimeout(updateDimensions, 250);
  }, [toolAreaOpen, whiteBoardOpen, updateDimensions]);

  return (
    <div className={classnames(classes.root)} ref={peersRef}>
      {spotlightPeers.map((peer, i) => {
        return (
          <Peer
            key={peer}
            id={peer}
            style={{ width: peerWidth, height: peerHeight }}
          />
        );
      })}
      <Me style={{ width: peerWidth, height: peerHeight }} />
    </div>
  );
};

export default Democratic;
